// extracted by mini-css-extract-plugin
module.exports =  {"phone-wrapper":"_0d624b9a27--phone-wrapper--bQ73x","qr-code-button":"_0d624b9a27--qr-code-button--FAclA","qr-code-icon":"_0d624b9a27--qr-code-icon--nUMjU"};